var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.canEditTournaments)?_c('router-link',{attrs:{"to":{
      name: 'TournamentDashboard',
      params: { tournamentID: _vm.id },
    }}},[_vm._t("default")],2):_c('LinkAccount',{attrs:{"id":_vm.id,"vanity-id":_vm.vanityId,"type":_vm.TOURNAMENT}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }